import React from 'react';
import PropTypes from 'prop-types';
import { Form, Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

// @import Custom Components
import { WriterlyFormikField } from '../../shared/Formik/FormikField';

// @import Utilities
import { camalize } from '../../utils/validations';

export const WriterlyAuthForm = ({
  formFields,
  formValidation,
  validationSchema,
  handleSubmit,
  formPage,
  extraFields,
  buttons,
}) => {
  const { pathname } = useLocation();

  const { t } = useTranslation();
  const passwordInputs = ['password', 'confirm_password'];
  return (
    <Formik
      initialValues={formFields}
      validate={formValidation}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
    >
      {({
        errors,
        touched,
        setFieldValue,
        values,
        setTouched,
        setErrors,
        handleBlur,
      }) => {
        return (
          <Form className="" autoComplete={'off'}>
            <div className="flex flex-col gap-5">
              {Object.keys(formFields).map((_field, index) => {
                return (
                  <WriterlyFormikField
                    key={index}
                    name={_field}
                    error={errors[_field]}
                    touched={touched[_field]}
                    value={values[_field]}
                    onChange={(e) => setFieldValue(`${_field}`, e.target.value)}
                    placeholder={t(
                      `${formPage}.form.fields.${camalize(_field)}.label`
                    )}
                    type={passwordInputs.includes(_field) ? 'password' : 'text'}
                    style={{ color: 'black' }}
                    onBlur={handleBlur}
                    disabled={
                      pathname.includes('join-your-team') && _field === 'email'
                    }
                  />
                );
              })}
              {extraFields}
            </div>
            <div className="buttons flex flex-col justify-center mt-5">
              {buttons}
            </div>
          </Form>
        );
      }}
    </Formik>
  );
};

WriterlyAuthForm.propTypes = {
  formFields: PropTypes.any.isRequired,
  formValidation: PropTypes.func,
  validationSchema: PropTypes.any,
  handleSubmit: PropTypes.func.isRequired,
  formPage: PropTypes.string.isRequired,
  extraFields: PropTypes.node,
  buttons: PropTypes.node.isRequired,
};
